import { render, staticRenderFns } from "./skeleton-element-four-col.vue?vue&type=template&id=3ae1c5d5&scoped=true"
import script from "./skeleton-element-four-col.vue?vue&type=script&lang=js"
export * from "./skeleton-element-four-col.vue?vue&type=script&lang=js"
import style0 from "./skeleton-element-four-col.vue?vue&type=style&index=0&id=3ae1c5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1c5d5",
  null
  
)

export default component.exports